import { Box, Link, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from '../../hooks/useTranslation';
import ConsentAcceptedIcon from '../../../src/assets/ConsetAccepted.svg';
import ConsentRejectedIcon from '../../../src/assets/ConsentRejected.svg';

function RedirectionCard(props) {
	const { t } = useTranslation();
	const theme = useTheme();
	const mobileScreen = useMediaQuery(theme.breakpoints.down('md'));
	const isMultipleConsent = global?.consentListLength > 1 ? true : false;

	const handleRedirect = () => {
		window.open('https://aaweb.finvu.in/', '_blank'); // Web App Prod link
	};

	// Determine if this is a success state
	const isSuccess = props.statusCode === 200;

	return (
		<Box
			sx={{
				display: 'flex',
				justifyContent: 'center',
				flexDirection: 'column',
				minHeight: '100vh',
				alignItems: 'center',
				padding: mobileScreen ? '0.5rem' : '3rem 1.875rem',
				width: '100%',
				backgroundColor: theme.palette.primary.light,
			}}
		>
			<Box
				sx={{
					padding: `${mobileScreen ? '1.5rem 1.5rem' : '2.5rem 4rem'}`,
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					textAlign: 'center',
					gap: '0.75rem',
					borderRadius: '8px',
					maxWidth: mobileScreen ? '600px' : '650px',
					width: mobileScreen ? '90%' : '100%',
					border: '1px solid #e0e0e0',
					margin: mobileScreen ? '2rem auto 0 auto' : '2rem 0 0 0',
				}}
			>
				{/* Status Icon */}
				<Box
					sx={{
						width: mobileScreen ? '3rem' : '4rem',
						height: mobileScreen ? '3rem' : '4rem',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<img
						src={isSuccess ? ConsentAcceptedIcon : ConsentRejectedIcon}
						alt={isSuccess ? 'Success' : 'Error'}
					/>
				</Box>

				{/* Original Title Text */}
				<Typography
					sx={{
						fontSize: mobileScreen ? '1.1rem' : '1.3rem',
						fontWeight: 700,
						color: theme.palette.primary.main,
						textAlign: 'center',
						mb: 0,
					}}
				>
					{props.statusCode === 20 || props.sessionError
						? t('redirection.titles.somethingWentWrong')
						: !isMultipleConsent
						? props.statusCode === 200
							? t('redirection.titles.dataSharingApproved')
							: props.statusCode === 410
							? t('redirection.titles.consentLinkExpired')
							: t('redirection.titles.dataSharingDenied')
						: t('redirection.titles.consentsActioned')}
				</Typography>

				{/* Original App Download Text */}
				<Box
					sx={{
						textAlign: 'center',
						display: 'inline-flex',
						flexWrap: mobileScreen ? 'wrap' : 'nowrap',
						justifyContent: 'center',
						gap: '2px',
						width: '100%',
					}}
				>
					<Typography component="span" sx={{ whiteSpace: 'nowrap' }}>
						{t('redirection.messages.downloadApp')}
					</Typography>
					<Link
						underline={'none'}
						onClick={handleRedirect}
						sx={{ cursor: 'pointer', whiteSpace: 'nowrap' }}
					>
						Finvu Web App
					</Link>
					<Typography component="span" sx={{ whiteSpace: 'nowrap' }}>
						{t('redirection.messages.manageConsents')}
					</Typography>
				</Box>

				{/* Original Redirection/Close Window Logic */}
				{global.isRedirect === 'true' && props.isCloseWindow === false ? (
					<>
						<Typography fontWeight={700} textAlign={'center'} mb={0}>
							Redirecting to {global.entityName} in
							<Typography
								component={'span'}
								fontSize="1.1rem"
								color={theme.palette.black60}
							>
								{' ' + props.time}
							</Typography>
						</Typography>
						<Typography
							sx={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								color: theme.palette.error.main,
								mt: 0,
							}}
						>
							Please DO NOT hit REFRESH or BACK
						</Typography>
					</>
				) : (
					<Typography fontWeight={700} textAlign={'center'}>
						{t('redirection.messages.closeWindow')}
					</Typography>
				)}
			</Box>
		</Box>
	);
}

export default RedirectionCard;
